import { Box, Heading, Page, Text } from '@zillow/constellation-10';

import LearnAboutPremiumButton, { RENDER_AS_TYPE } from '../LearnAboutPremiumButton';

import ProductFeatureCompareTable from '../ProductFeatureCompareTable';
import PremiumUpsell from '../PremiumUpsell';

const propTypes = {};
const defaultProps = {};

const PremiumCompare = () => {
  return (
    <div data-testid="PremiumCompare">
      <Box css={{ xxlDown: { width: '90%', margin: 'auto' }, '@media (min-width: 1440px)': { width: '100vw' } }}>
        <Page.Content
          css={{
            padding: '400',
            width: '100%',
            boxSizing: 'border-box',
            margin: '0 !important',
            marginBottom: '{spacing.-800}',
            paddingBottom: '0',
            maxWidth: '1232px',
          }}
        >
          <Heading level={4} fontFamily="heading-alt" css={{ marginBottom: '200', marginTop: '400' }}>
            Get the edge you need to fill your listing fast with premium
          </Heading>

          <Text asChild css={{ marginBottom: '400' }}>
            <p>
              Receive higher quality leads, gain deeper insights on how to optimize your listing, and find your perfect
              renter even faster.
            </p>
          </Text>
          <Box css={{ marginBottom: { base: 0, xl: '1200' } }}>
            <ProductFeatureCompareTable />
          </Box>
          <Box css={{ display: { base: 'block', xxl: 'none' } }}>
            <Box css={{ marginBlock: '1200', textAlign: 'center' }}>
              <LearnAboutPremiumButton as={RENDER_AS_TYPE.BUTTON}>Learn more</LearnAboutPremiumButton>
            </Box>

            <PremiumUpsell />
          </Box>
        </Page.Content>
      </Box>
    </div>
  );
};

PremiumCompare.propTypes = propTypes;
PremiumCompare.defaultProps = defaultProps;

export default PremiumCompare;
